import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { ShareComparisonButton } from "../ShareComparisonButton";

export default function ComparePlayersHeader({
  onBack,
  activeTab,
  setActiveTab,
  comparisonRef,
}) {
  return (
    <div className="grid grid-cols-[auto_1fr_auto] items-center gap-3 border-b px-4 py-3">
      <button
        type="button"
        onClick={onBack}
        className="inline-flex items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-sm font-medium text-blue-600 hover:bg-gray-50 hover:text-blue-800"
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        Back
      </button>
      <h2 className="text-lg sm:text-xl font-semibold text-gray-800">
        Compare Players
      </h2>

      <div className="flex flex-wrap justify-center gap-0 mr-8">
        <button
          onClick={() => setActiveTab("trackit")}
          className={`px-3 sm:px-4 py-2 border rounded-l-md font-medium text-sm border-blue-500 ${
            activeTab === "trackit"
              ? "bg-blue-100 border-blue-500 text-blue-600"
              : "text-gray-600"
          }`}
        >
          Trackit Score
        </button>
        <button
          onClick={() => setActiveTab("position")}
          className={`px-3 sm:px-4 py-2 border rounded-r-md font-medium text-sm border-blue-500 ${
            activeTab === "position"
              ? "bg-blue-100 border-blue-500 text-blue-600"
              : "text-gray-600"
          }`}
        >
          Position Score
        </button>
        <ShareComparisonButton comparisonRef={comparisonRef} />
      </div>
    </div>
  );
}
